// Section 03 — "Try it". Three playable mini-demos, fully client-side on
// embedded mock data: the dashboard with cell drill-down, the five-tier
// classification cascade, and the snapshot-on-save forecast grid.

import React from 'react';
import DemoDashboard from './DemoDashboard';
import DemoCascade from './DemoCascade';
import DemoForecast from './DemoForecast';

const DEMOS = [
  {
    letter: 'a',
    title: 'The dashboard — click any cell',
    sub:
      'The same owner → category → line tree as the main sheet, with live Budget / Actual / ' +
      'Committed / Variance per quarter. Every number can answer for itself: click a quarter ' +
      'cell on a line to see the SAP rows and invoices behind it.',
    body: <DemoDashboard />,
  },
  {
    letter: 'b',
    title: 'Classification — watch a row find its line',
    sub:
      'Every SAP row must end up on a budget line. Cheap, deterministic rules go first; the AI ' +
      'is only asked when they all pass — and you always get the final word.',
    body: <DemoCascade />,
  },
  {
    letter: 'c',
    title: 'Forecasting — revise without fear',
    sub:
      'The FP&A template, live: twelve monthly inputs per vendor row, quarters and annual ' +
      'derived as you type. Saving never edits the past — it adds a snapshot to the history.',
    body: <DemoForecast />,
  },
];

export default function TryItSection() {
  return (
    <section id="tut-try" className="tut-section">
      <div className="tut-kicker">03 · Hands on</div>
      <h2>Try it</h2>
      <p className="tut-lead">
        Three working miniatures of the real module. Everything below runs right here on sample
        data — click around.
      </p>
      {DEMOS.map((d) => (
        <div key={d.letter} className="tut-demo">
          <div className="tut-demo-head">
            <span className="tut-demo-letter">{d.letter}</span>
            <div>
              <h3>{d.title}</h3>
              <p className="tut-demo-sub">{d.sub}</p>
            </div>
          </div>
          {d.body}
        </div>
      ))}
    </section>
  );
}
